export function expectJsonRecord(value, context) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        throw new Error(`Invalid payload at ${context}: expected object`);
    }
    return value;
}
export function parseJsonRecord(raw, context) {
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch (err) {
        throw new Error(err instanceof Error ? `Invalid JSON at ${context}: ${err.message}` : `Invalid JSON at ${context}`);
    }
    return expectJsonRecord(parsed, context);
}
export function requireArray(root, key, context) {
    const value = root[key];
    if (!Array.isArray(value)) {
        throw new Error(`Invalid payload at ${context}.${key}: expected array`);
    }
    return value;
}
//# sourceMappingURL=runtime-validation.js.map